module.exports = __webpack_public_path__ + "img/v21.08cfda5c.jpg";